<template>
  <div class="container">
      <div class="notification is-dvodark">
          <div class="columns py-2 is-centered">
              <div class="column is-one-fifth is-offset-two-fifths has-text-centered">
                  <h1 class="is-size-3">
                      MY ACCOUNT
                  </h1>
              </div>
              <div class="column is-one-fifth is-offset-one-fifth">
                <div class="buttons">
                    <b-button @click="changePasswordModal()" class="is-small is-danger"> 
                    Change Password
                    </b-button>                
                </div>
              </div>
          </div>
          <div class="container has-background-dvoalt is-larger">
              <div class="columns py-2 is-centered">
                  <div class="column">
                      <b-field horizontal label="First Name">
                          <b-input v-model="firstName"></b-input>
                      </b-field>
                  </div>
                  <div class="column">
                      <b-field horizontal label="Last Name">
                          <b-input v-model="lastName"></b-input>
                      </b-field>
                  </div>
              </div>
            <div class="columns py-2 is-centered has-background-dvodark">
                  <div class="column">
                      <b-field horizontal label="Address">
                          <b-input v-model="address"></b-input>
                      </b-field>
                  </div>
                  <div class="column">
                      <b-field horizontal label="Country">
                          <b-input v-model="country"></b-input>
                      </b-field>
                  </div>
              </div>
              <div class="columns py-2 has-background-dvoalt">
                  <div class="column is-half">
                      <b-field horizontal label="My Email">
                          <b-input v-model="email" disabled></b-input>
                      </b-field>
                  </div>
              </div>
              <div class="columns py-2 is-centered has-background-dvodark has-text-centered">
                  <div class="column is-one-fifth ">
                      <div class="has-text-centered">
                            <button class="button is-medium is-dvogreen my-2" @click="updateName()">Update Information</button>
                      </div>
                  </div>
              </div>
          </div>
          <section class="section is-small" v-if="userCompany">
                <b-collapse
                    v-for="(item, index) in userCompany" :key=index
                    :open="isOpen == index"
                     @open="isOpen = index"
                    aria-id="contentIdForA11y2"
                    class="panel"
                    animation="slide">
                    <div
                        slot="trigger"
                        slot-scope="props"
                        class="panel-heading has-background-dvoalt has-text-dvogreen"
                        role="button"
                        aria-controls="contentIdForA11y2"
                        >
                        <strong class="is-size-3">{{userCompany[index].name}}</strong>
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </div>
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Company Name">
                            <b-input v-model="userCompany[index].name"></b-input>
                        </b-field>
                    </div>
                 <div class="column">
                        <b-field horizontal label="Date Created">
                            <span v-if="userCompany" class="tag is-medium is-dvogreen">
                                {{ new Date(userCompany[index].date_created).toLocaleDateString() }}
                            </span>
                        </b-field>
                    </div>
                    </div>
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Phone Number">
                            <b-input v-model="userCompany[index].phone_number"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field horizontal label="Fax Number">
                            <b-input v-model="userCompany[index].fax_number"></b-input>
                        </b-field>
                    </div>
                    </div> 
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Main Contact">
                            <b-input v-model="userCompany[index].main_contact"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field horizontal label="Main Contact Email">
                            <b-input v-model="userCompany[index].main_contact_email"></b-input>
                        </b-field>
                    </div>
                    </div> 
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Billing Contact">
                            <b-input v-model="userCompany[index].billing_contact"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field horizontal label="Billing Email">
                            <b-input v-model="userCompany[index].billing_email"></b-input>
                        </b-field>
                    </div>
                    </div> 
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Sales Contact">
                            <b-input v-model="userCompany[index].sales_contact"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field horizontal label="Sales Email">
                            <b-input v-model="userCompany[index].sales_email"></b-input>
                        </b-field>
                    </div>
                    </div>
                    <div class="panel-block">
                    <div class="column">
                        <b-field horizontal label="Landed %">
                            <b-input :value="userCompany[index].landing_percent" disabled></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field horizontal label="Labor Rate">
                            <b-input :value="userCompany[index].labor_cost" disabled></b-input>
                        </b-field>
                    </div>
                    </div>
                    <div class="columns py-2 is-centered has-background-dvodark has-text-centered">
                    <div class="column is-one-third ">
                        <div class="buttons">
                            <button v-if="userCompany[index].roles.includes('can-edit-company-information')"
                            class="button is-dvogreen"
                            :loading="isUpdating"
                            :disabled="isUpdating"
                            @click="updateCompany(index)">
                            Update Information
                            </button>
                            <b-button
                            v-if="userCompany[index].roles.includes('can-add-person-to-company')" 
                            class=" is-info" 
                            @click="addUserToCompanyModal(userCompany[index])">
                            Add User to Company
                            </b-button>
                            <!-- <b-button class="is-medium is-warning">Manage Company</b-button> -->
                        </div>
                    </div>
                </div>
                </b-collapse>
          </section>
          <section class="section">
              <div class="columns has-text-centered">
                  <div class="column ">
                      Are you a distributor? Is your company currently not registered with the DVO B2B system? Apply now!
                  </div> 
              </div>
              <div class="columns  has-text-centered">
                  <div class="column">
                    <b-button class="is-medium is-dvogreen" @click="addCompanyModal(id)">Click Here</b-button>
                  </div>
              </div>
          </section>
      </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import Auth from "@aws-amplify/auth";
import { mapGetters } from "vuex";
import { personHandler, companyFromPersonCompanyRoleHandler, companyHandler } from '../graphql/mutations'
import AddCompany from './AddCompany.vue'
import ChangePasswordModal from './ChangePasswordModal.vue'
import AddUserToCompanyModal from './AddUserToCompanyModal'

export default {
    data() {
            return {
                firstName: "",
                lastName: "",
                address: "",
                country: "",
                email: null,
                id: null,
                user: null,
                userCompany: [],
                isOpen: 0,
                isUpdating: false
            }
        },
        computed: {
            ...mapGetters("auth", ["hasAuthenticationStatus"])
        },
        methods: {
            async getUserInfo() {
                const cognitoUser = await Auth.currentAuthenticatedUser();

                const userInput = {
                    cognito_id: cognitoUser.attributes.sub,
                    request_type: 'read_by_cognito_id'
                };

                const dvoUser = await API.graphql({
                    query: personHandler,
                    variables: {
                        input: userInput
                    }
                });

                if (dvoUser.data.personHandler) {
                    if (dvoUser.data.personHandler.first_name || dvoUser.data.personHandler.last_name || dvoUser.data.personHandler.email) {
                        this.firstName = dvoUser.data.personHandler.first_name
                        this.lastName = dvoUser.data.personHandler.last_name
                        this.address = dvoUser.data.personHandler.address
                        this.country = dvoUser.data.personHandler.country
                        this.email = dvoUser.data.personHandler.email
                    }
                } else {
                    this.firstName = ''
                    this.lastName = ''
                    this.email = ''
                }

                this.id = dvoUser.data.personHandler.id

                const userCompany = await API.graphql({
                    query: companyFromPersonCompanyRoleHandler,
                    variables: {
                        input: {
                            request_type: 'find_company_by_user',
                            user_id: this.id
                        }
                    }
                });
                const holder = userCompany.data.companyFromPersonCompanyRoleHandler
                let seenId = []
                for (let i = 0; i < holder.length; i++) {
                    if (seenId.includes(holder[i].company_id)) {
                        for (let j = 0; j < this.userCompany.length; j++) {
                            if (this.userCompany[j].company_id === holder[i].company_id) {
                                this.userCompany[j].roles.push(holder[i].role_name)
                            }
                        }
                    } else {
                        seenId.push(holder[i].company_id)
                        holder[i]['roles'] = []
                        holder[i].roles.push(holder[i].role_name)
                        this.userCompany.push(holder[i])
                    }
                }
            },
            async updateName() {
                this.isLoading = true
                const cognitoUser = await Auth.currentAuthenticatedUser();
                const thing = await API.graphql({
                    query: personHandler,
                    variables: {
                        input: {
                            id: this.id,
                            first_name: this.firstName,
                            last_name: this.lastName,
                            email: this.email,
                            cognito_id: cognitoUser.attributes.sub,
                            address: this.address,
                            country: this.country,
                            request_type: 'update'
                        }
                    }
                })

                console.log(thing)
                this.isLoading = false
            },
            addCompanyModal(id) {
                this.$buefy.modal.open({
                    parent: this,
                    component: AddCompany,
                    hasModalCard: true,
                    trapFocus: true,
                    props: {
                        userId: id,
                    }
                })
            },
            changePasswordModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: ChangePasswordModal,
                    hasModalCard: true,
                    trapFocus: true,
                    events: {
                        'close': value => {
                            console.log(value)
                        }
                    }
                })
            },
            addUserToCompanyModal(id) {
                this.$buefy.modal.open({
                    parent: this,
                    component: AddUserToCompanyModal,
                    hasModalCard: true,
                    trapFocus: true,
                    props: {
                        companyId: id
                    },
                    events: {
                        'close': value => {
                            console.log(value)
                        }
                    }
                })
            },
            async updateCompany(index) {
                this.isUpdating = true
                this.userCompany[index].request_type = 'update'
                const {
                    name,
                    company_id,
                    address,
                    landing_percent,
                    labor_cost,
                    principal_person,
                    date_created,
                    phone_number,
                    fax_number,
                    main_contact,
                    main_contact_email,
                    sales_contact,
                    sales_email,
                    service_center,
                    distributor_type,
                    billing_contact,
                    billing_email,
                    status,
                    discount,
                    request_type
                } = this.userCompany[index]
                await API.graphql({
                    query: companyHandler,
                    variables: {
                        input: {
                            request_type: request_type,
                            id: company_id,
                            name: name,
                            address: address,
                            landing_percent: landing_percent,
                            labor_cost: labor_cost,
                            principal_person: principal_person,
                            date_created: date_created,
                            phone_number: phone_number,
                            fax_number: fax_number,
                            main_contact: main_contact,
                            main_contact_email: main_contact_email,
                            sales_contact: sales_contact,
                            sales_email: sales_email,
                            service_center: service_center,
                            distributor_type: distributor_type,
                            billing_contact: billing_contact,
                            billing_email: billing_email,
                            status: status,
                            discount: discount
                        }
                    }
                });
                this.isUpdating = false
            }
        },
        async mounted() {
            await this.getUserInfo();
        }
    }
</script>

<style lang="scss">
.is-larger{
  .field-label .label {
    color: #82bc00 !important;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    font-weight: 900;
    }  
}
.field-label .label {
    color: #82bc00 !important;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
}

input[type="text"], textarea {
  background-color : transparent; 
  color: white;
}


h1 {
  font-family: 'Anton', sans-serif;
}

p {
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
}
</style>